// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1qi8JryjyR8RiY {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  padding: 1rem;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoLink": "_1qi8JryjyR8RiY"
};
export default ___CSS_LOADER_EXPORT___;
